export const SCHEDULED_MAINTENANCE = "maintenance"
export const SERVICE_FAILURE = "failure"
